/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: c10dd50c3c15
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  MoveFolderRequest,
  MoveFolderRequest$zodSchema,
} from "./movefolderrequest.js";
import {
  MoveFolderResponse,
  MoveFolderResponse$zodSchema,
} from "./movefolderresponse.js";

export type UpdateFolderGlobals = { cloud_name?: string | undefined };

export const UpdateFolderGlobals$zodSchema: z.ZodType<UpdateFolderGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type UpdateFolderRequest = {
  folder: string;
  move_folder_request: MoveFolderRequest;
};

export const UpdateFolderRequest$zodSchema: z.ZodType<UpdateFolderRequest> = z
  .object({
    folder: z.string().describe(
      "The full path of the folder, including any nested folders. Must not be empty, and must not contain double slashes or leading/trailing slashes.",
    ),
    move_folder_request: MoveFolderRequest$zodSchema.describe(
      "The new folder path.",
    ),
  });

export type UpdateFolderResponse = MoveFolderResponse | ApiError;

export const UpdateFolderResponse$zodSchema: z.ZodType<UpdateFolderResponse> = z
  .union([
    MoveFolderResponse$zodSchema,
    ApiError$zodSchema,
  ]);
